// YNX — i18n dictionary for the public Landing Page.
// 5 languages: French (default), English, Spanish, German, Italian.
// The translation key set is intentionally limited to the Landing Page —
// the authenticated business hub remains in French (its B2B users will be
// French/EU companies; can be extended later).
// ───────────────────────────────────────────────────────────────

export const LANGS = [
  { code: 'fr', label: 'Français',   flag: '🇫🇷' },
  { code: 'en', label: 'English',    flag: '🇬🇧' },
  { code: 'es', label: 'Español',    flag: '🇪🇸' },
  { code: 'de', label: 'Deutsch',    flag: '🇩🇪' },
  { code: 'it', label: 'Italiano',   flag: '🇮🇹' },
];

export const DICT = {
  fr: {
    nav: { features: 'Fonctionnalités', pricing: 'Tarifs', faq: 'FAQ', login: 'Se connecter', start: 'Démarrer' },
    hero: {
      badge: 'Nouveau · L\'OS IA des entreprises',
      title1: 'Tout votre business',
      title2: 'dans un seul outil.',
      sub: 'Agenda · Devis · Factures · Clients · Tâches · Annuaire · Studio IA',
      sub2: 'Conçu pour les TPE/PME du monde entier. Conforme. Souverain. Illimité.',
      ctaPrimary: 'Démarrer gratuitement',
      ctaSecondary: 'J\'ai déjà un code',
      trust1: 'Aucune carte bancaire requise',
      trust2: 'Setup en 60 secondes',
      trust3: 'RGPD · Hébergement UE',
    },
    proof: {
      modules: 'modules\nintégrés', compliance: 'conforme\nréglementation', setup: 'pour\ndémarrer', unlimited: 'factures &\nclients',
    },
    features: {
      tag: 'FONCTIONNALITÉS',
      title1: '9 modules pour gérer',
      title2: 'toute votre entreprise',
      sub: 'Plus besoin de jongler entre 5 logiciels. YNX réunit tout ce dont une entreprise moderne a besoin pour fonctionner au quotidien — avec une couche d\'IA partout où c\'est utile.',
      items: [
        { title: 'Agenda partagé',         desc: 'RDV clients, rappels automatiques, vue par jour/semaine/mois.' },
        { title: 'Tâches en Kanban',       desc: 'À faire / en cours / terminé. Priorités, échéances, assignation.' },
        { title: 'Devis & Factures',       desc: 'Numérotation auto, TVA, export PDF & Word, mentions légales.' },
        { title: 'CRM Clients',            desc: 'SIRET, TVA, historique, notes, recherche instantanée.' },
        { title: 'Annuaire interne',       desc: 'Extensions auto, messagerie interne gratuite, click-to-call.' },
        { title: 'Studio Visuel IA',       desc: 'Flyers, affiches, visuels marketing en 1 clic — illimité.' },
        { title: 'Assistant IA',           desc: 'GPT, Claude, Gemini. Recherche web, analyse de fichiers.' },
        { title: 'Équipe multi-utilisateurs', desc: 'Admin · Comptable · Commercial · Collaborateur. RBAC complet.' },
        { title: 'RGPD & souveraineté',    desc: 'Données isolées par entreprise, hébergées en UE, exportables.' },
      ],
    },
    pricing: {
      tag: 'TARIFS', title1: 'Une promesse simple :', title2: 'vous payez quand ça marche',
      sub: 'Démarrez gratuitement. Passez Indépendant ou Entreprise quand vous voulez débloquer plus. Pas de paliers cachés.',
      plans: [
        { name: 'Starter', price: '0', tag: 'GRATUIT', period: 'à vie',
          desc: 'Pour découvrir YNX sans risque.',
          features: ['1 utilisateur', '20 factures / mois', '50 clients', 'Modules essentiels', 'Support communautaire'],
          cta: 'Démarrer gratuitement' },
        { name: 'Indépendant', price: '19', tag: 'POPULAIRE', period: '/ mois',
          desc: 'Pour les indépendants et auto-entrepreneurs.',
          features: ['1 utilisateur', '50 factures / mois', '200 clients', 'Tous les modules', 'Assistant IA limité', 'Studio IA limité'],
          cta: 'S\'abonner — 19€/mois', highlighted: true },
        { name: 'Entreprise', price: '500', tag: 'PME', period: '/ mois',
          desc: 'Pour les TPE/PME qui veulent tout débloquer.',
          features: ['Utilisateurs illimités', 'Factures illimitées', 'Clients illimités', 'IA illimitée', 'Stripe Connect', 'IMAP/SMTP', 'Support prioritaire 24h'],
          cta: 'S\'abonner — 500€/mois' },
      ],
      addonsTitle: 'Options à la carte — +200€/mois chacune',
      addonsSub: 'Activez uniquement ce dont vous avez besoin. Chaque option se cumule à votre plan Entreprise.',
      addons: [
        { title: 'Marque blanche',           desc: 'Domaine custom · Logo + couleurs · Pas de mention YNX.' },
        { title: 'Multi-pays & langues',     desc: 'Factures bilingues · TVA UE · 5 langues clients.' },
        { title: 'Studio IA illimité',       desc: 'Nano Banana illimité · GPT-5 illimité · Recherche web illimitée.' },
        { title: 'Support prioritaire 24/7', desc: 'Hotline directe Carl TACITA · SLA 2h · Onboarding personnalisé.' },
      ],
    },
    why: {
      tag: 'POURQUOI YNX', title1: 'Conçu par un entrepreneur', title2: 'pour des entrepreneurs.',
      text: 'YNX a été créé par Carl TACITA, qui en avait assez de payer 5 outils différents pour faire tourner sa TPE. La promesse : un seul abonnement, un seul login, toutes les briques essentielles d\'une entreprise moderne.',
      p1: ['Rapide.', 'Tout est local + cloud. Pas d\'attente.'],
      p2: ['Souverain.', 'Données en UE, exportables à tout moment.'],
      p3: ['Multi-tenant.', 'Vos données strictement isolées des autres entreprises.'],
    },
    faq: {
      tag: 'FAQ', title: 'Les questions qu\'on nous pose',
      items: [
        ['Mes données sont-elles vraiment isolées des autres entreprises ?', 'Oui. Chaque entreprise possède un workspace unique avec un code YNX-XXXXXX. Toutes les données sont strictement isolées au niveau base de données.'],
        ['Puis-je récupérer mes données si je quitte YNX ?', 'Oui, à tout moment. Factures en PDF/Word, clients en CSV, export complet JSON sur demande. Aucun lock-in.'],
        ['YNX est-il conforme à la réglementation française et européenne ?', 'Oui. Numérotation séquentielle, mentions légales, TVA UE, archivage 10 ans. Hébergement en UE (RGPD).'],
        ['Combien de temps pour démarrer ?', 'Moins de 60 secondes. Nom d\'entreprise → code d\'accès → première facture immédiatement.'],
        ['Comment fonctionne l\'abonnement Stripe ?', 'Vous payez par tranche de 30 jours via carte bancaire. Pas de prélèvement automatique forcé. Vous gardez vos données même hors abonnement.'],
      ],
    },
    finalCta: {
      title: 'Prêt à gagner 2 heures par jour ?',
      sub: 'Créez votre espace entreprise en 60 secondes. Aucune carte bancaire requise.',
      cta: 'Démarrer maintenant',
    },
    footer: {
      tag: 'L\'OS IA des entreprises',
      product: 'Produit', legal: 'Légal', contact: 'Contact',
      legalMentions: 'Mentions légales', cgu: 'CGU', rgpd: 'RGPD',
      copyright: '© 2026 YNX by Carl TACITA · Tous droits réservés · Hébergé en UE',
    },
  },

  en: {
    nav: { features: 'Features', pricing: 'Pricing', faq: 'FAQ', login: 'Log in', start: 'Get started' },
    hero: {
      badge: 'New · The AI OS for businesses',
      title1: 'Run your entire business',
      title2: 'from a single tool.',
      sub: 'Calendar · Quotes · Invoices · CRM · Tasks · Directory · AI Studio',
      sub2: 'Built for SMBs worldwide. Compliant. Sovereign. Unlimited.',
      ctaPrimary: 'Start free',
      ctaSecondary: 'I have a code',
      trust1: 'No credit card required',
      trust2: '60-second setup',
      trust3: 'GDPR · EU hosting',
    },
    proof: { modules: 'modules\nincluded', compliance: 'fully\ncompliant', setup: 'to get\nstarted', unlimited: 'invoices &\nclients' },
    features: {
      tag: 'FEATURES',
      title1: '9 modules to run',
      title2: 'your entire business',
      sub: 'No more juggling 5 different tools. YNX bundles everything a modern business needs — with AI everywhere it matters.',
      items: [
        { title: 'Shared calendar',     desc: 'Client appointments, auto reminders, day/week/month view.' },
        { title: 'Kanban tasks',        desc: 'To do / doing / done. Priorities, deadlines, assignment.' },
        { title: 'Quotes & invoices',   desc: 'Auto numbering, VAT, PDF & Word export, legal mentions.' },
        { title: 'CRM',                 desc: 'Tax ID, VAT, history, notes, instant search.' },
        { title: 'Internal directory',  desc: 'Auto extensions, free internal messaging, click-to-call.' },
        { title: 'AI Visual Studio',    desc: 'Flyers, posters, marketing visuals in one click — unlimited.' },
        { title: 'AI Assistant',        desc: 'GPT, Claude, Gemini. Web search, file analysis.' },
        { title: 'Multi-user team',     desc: 'Admin · Accountant · Sales · Member. Full RBAC.' },
        { title: 'GDPR & sovereignty',  desc: 'Data isolated per company, EU-hosted, exportable.' },
      ],
    },
    pricing: {
      tag: 'PRICING', title1: 'Simple promise:', title2: 'pay only when it works for you',
      sub: 'Start free. Upgrade to Solo or Business when you want to unlock more. No hidden tiers.',
      plans: [
        { name: 'Starter', price: '0', tag: 'FREE', period: 'forever',
          desc: 'Discover YNX with zero risk.',
          features: ['1 user', '20 invoices / month', '50 clients', 'Essential modules', 'Community support'],
          cta: 'Start free' },
        { name: 'Solo', price: '19', tag: 'POPULAR', period: '/ month',
          desc: 'For freelancers and solopreneurs.',
          features: ['1 user', '50 invoices / month', '200 clients', 'All modules', 'Limited AI', 'Limited AI Studio'],
          cta: 'Subscribe — €19/month', highlighted: true },
        { name: 'Business', price: '500', tag: 'SMB', period: '/ month',
          desc: 'For SMBs that want to unlock everything.',
          features: ['Unlimited users', 'Unlimited invoices', 'Unlimited clients', 'Unlimited AI', 'Stripe Connect', 'IMAP/SMTP', 'Priority 24h support'],
          cta: 'Subscribe — €500/month' },
      ],
      addonsTitle: 'À la carte add-ons — +€200/month each',
      addonsSub: 'Only activate what you need. Each add-on stacks on top of Business.',
      addons: [
        { title: 'White-label',          desc: 'Custom domain · Logo + colors · No YNX mention.' },
        { title: 'Multi-country & languages', desc: 'Bilingual invoices · EU VAT · 5 client languages.' },
        { title: 'Unlimited AI Studio', desc: 'Unlimited Nano Banana · Unlimited GPT-5 · Unlimited web search.' },
        { title: '24/7 priority support', desc: 'Direct hotline to Carl TACITA · 2h SLA · Personal onboarding.' },
      ],
    },
    why: {
      tag: 'WHY YNX', title1: 'Built by an entrepreneur', title2: 'for entrepreneurs.',
      text: 'YNX was built by Carl TACITA, who was tired of paying for 5 different tools to run his small business. The promise: one subscription, one login, every brick a modern business needs.',
      p1: ['Fast.', 'Local + cloud. No waiting.'],
      p2: ['Sovereign.', 'EU-hosted data, exportable anytime.'],
      p3: ['Multi-tenant.', 'Your data strictly isolated from other companies.'],
    },
    faq: {
      tag: 'FAQ', title: 'Frequently asked',
      items: [
        ['Is my data truly isolated from other companies?', 'Yes. Each company gets a unique workspace with a YNX-XXXXXX code. All data is strictly isolated at the database level.'],
        ['Can I get my data back if I leave YNX?', 'Anytime. Invoices in PDF/Word, clients in CSV, full JSON export on request. No lock-in.'],
        ['Is YNX compliant with EU regulations?', 'Yes. Sequential numbering, legal mentions, EU VAT, 10-year archival. EU hosting (GDPR).'],
        ['How long to get started?', 'Less than 60 seconds. Company name → access code → first invoice immediately.'],
        ['How does the Stripe subscription work?', 'You pay in 30-day blocks via credit card. No forced auto-debit. Your data stays accessible even off-subscription.'],
      ],
    },
    finalCta: {
      title: 'Ready to save 2 hours a day?',
      sub: 'Create your workspace in 60 seconds. No credit card required.',
      cta: 'Get started now',
    },
    footer: {
      tag: 'The AI OS for businesses',
      product: 'Product', legal: 'Legal', contact: 'Contact',
      legalMentions: 'Legal notices', cgu: 'Terms', rgpd: 'Privacy',
      copyright: '© 2026 YNX by Carl TACITA · All rights reserved · EU hosted',
    },
  },

  es: {
    nav: { features: 'Funcionalidades', pricing: 'Precios', faq: 'FAQ', login: 'Acceder', start: 'Comenzar' },
    hero: {
      badge: 'Nuevo · El OS de IA para empresas',
      title1: 'Todo tu negocio',
      title2: 'en una sola herramienta.',
      sub: 'Agenda · Presupuestos · Facturas · Clientes · Tareas · Directorio · Estudio IA',
      sub2: 'Diseñado para pymes de todo el mundo. Conforme. Soberano. Ilimitado.',
      ctaPrimary: 'Empezar gratis',
      ctaSecondary: 'Ya tengo un código',
      trust1: 'Sin tarjeta de crédito',
      trust2: 'Configuración en 60 segundos',
      trust3: 'GDPR · Alojamiento UE',
    },
    proof: { modules: 'módulos\nincluidos', compliance: 'cumplimiento\ntotal', setup: 'para\nempezar', unlimited: 'facturas y\nclientes' },
    features: {
      tag: 'FUNCIONALIDADES',
      title1: '9 módulos para gestionar',
      title2: 'toda tu empresa',
      sub: 'Ya no necesitas malabarear con 5 herramientas. YNX reúne todo lo que una pyme moderna necesita — con IA donde realmente cuenta.',
      items: [
        { title: 'Agenda compartida',    desc: 'Citas, recordatorios automáticos, vista día/semana/mes.' },
        { title: 'Tareas Kanban',        desc: 'Por hacer / haciendo / hecho. Prioridades, asignación.' },
        { title: 'Presupuestos & Facturas', desc: 'Numeración auto, IVA, export PDF & Word, menciones legales.' },
        { title: 'CRM',                  desc: 'NIF/CIF, IVA, historial, notas, búsqueda instantánea.' },
        { title: 'Directorio interno',   desc: 'Extensiones automáticas, mensajería gratis, click-to-call.' },
        { title: 'Estudio Visual IA',    desc: 'Flyers, carteles, visuales en 1 clic — ilimitado.' },
        { title: 'Asistente IA',         desc: 'GPT, Claude, Gemini. Búsqueda web, análisis de archivos.' },
        { title: 'Equipo multi-usuario', desc: 'Admin · Contable · Comercial · Colaborador. RBAC completo.' },
        { title: 'GDPR & soberanía',     desc: 'Datos aislados por empresa, alojados en UE, exportables.' },
      ],
    },
    pricing: {
      tag: 'PRECIOS', title1: 'Promesa simple:', title2: 'pagas cuando funciona',
      sub: 'Empieza gratis. Pasa a Independiente o Empresa cuando quieras más. Sin niveles ocultos.',
      plans: [
        { name: 'Starter', price: '0', tag: 'GRATIS', period: 'siempre',
          desc: 'Descubre YNX sin riesgo.',
          features: ['1 usuario', '20 facturas / mes', '50 clientes', 'Módulos esenciales', 'Soporte comunitario'],
          cta: 'Empezar gratis' },
        { name: 'Independiente', price: '19', tag: 'POPULAR', period: '/ mes',
          desc: 'Para autónomos y freelancers.',
          features: ['1 usuario', '50 facturas / mes', '200 clientes', 'Todos los módulos', 'IA limitada', 'Estudio IA limitado'],
          cta: 'Suscribir — 19€/mes', highlighted: true },
        { name: 'Empresa', price: '500', tag: 'PYME', period: '/ mes',
          desc: 'Para pymes que quieren desbloquearlo todo.',
          features: ['Usuarios ilimitados', 'Facturas ilimitadas', 'Clientes ilimitados', 'IA ilimitada', 'Stripe Connect', 'IMAP/SMTP', 'Soporte prioritario 24h'],
          cta: 'Suscribir — 500€/mes' },
      ],
      addonsTitle: 'Opciones a la carta — +200€/mes cada una',
      addonsSub: 'Activa solo lo que necesitas. Cada opción se suma a Empresa.',
      addons: [
        { title: 'Marca blanca',          desc: 'Dominio propio · Logo + colores · Sin mención YNX.' },
        { title: 'Multi-país e idiomas',  desc: 'Facturas bilingües · IVA UE · 5 idiomas para clientes.' },
        { title: 'Estudio IA ilimitado', desc: 'Nano Banana ilimitado · GPT-5 ilimitado · Búsqueda web ilimitada.' },
        { title: 'Soporte 24/7',          desc: 'Línea directa con Carl TACITA · SLA 2h · Onboarding personal.' },
      ],
    },
    why: {
      tag: 'POR QUÉ YNX', title1: 'Hecho por un emprendedor', title2: 'para emprendedores.',
      text: 'YNX fue creado por Carl TACITA, harto de pagar 5 herramientas distintas para gestionar su pyme. La promesa: una sola suscripción, un solo acceso, todas las piezas que una empresa moderna necesita.',
      p1: ['Rápido.', 'Local + nube. Sin esperas.'],
      p2: ['Soberano.', 'Datos en UE, exportables cuando quieras.'],
      p3: ['Multi-tenant.', 'Tus datos completamente aislados de otras empresas.'],
    },
    faq: {
      tag: 'FAQ', title: 'Preguntas frecuentes',
      items: [
        ['¿Mis datos están realmente aislados?', 'Sí. Cada empresa tiene un workspace único con código YNX-XXXXXX. Aislamiento estricto a nivel base de datos.'],
        ['¿Puedo recuperar mis datos si me voy?', 'En cualquier momento. PDF/Word para facturas, CSV para clientes, JSON completo bajo demanda. Sin lock-in.'],
        ['¿YNX cumple las regulaciones europeas?', 'Sí. Numeración secuencial, menciones legales, IVA UE, archivado 10 años. Alojamiento UE (GDPR).'],
        ['¿Cuánto tarda en arrancar?', 'Menos de 60 segundos. Nombre → código de acceso → primera factura inmediatamente.'],
        ['¿Cómo funciona la suscripción Stripe?', 'Pagas en bloques de 30 días con tarjeta. Sin domiciliación obligatoria. Conservas el acceso a tus datos aunque pares.'],
      ],
    },
    finalCta: {
      title: '¿Listo para ganar 2 horas al día?',
      sub: 'Crea tu espacio empresarial en 60 segundos. Sin tarjeta.',
      cta: 'Empezar ahora',
    },
    footer: {
      tag: 'El OS de IA para empresas',
      product: 'Producto', legal: 'Legal', contact: 'Contacto',
      legalMentions: 'Aviso legal', cgu: 'Términos', rgpd: 'Privacidad',
      copyright: '© 2026 YNX by Carl TACITA · Todos los derechos reservados · Alojado en UE',
    },
  },

  de: {
    nav: { features: 'Funktionen', pricing: 'Preise', faq: 'FAQ', login: 'Anmelden', start: 'Starten' },
    hero: {
      badge: 'Neu · Das KI-OS für Unternehmen',
      title1: 'Dein gesamtes Business',
      title2: 'in einem einzigen Tool.',
      sub: 'Kalender · Angebote · Rechnungen · CRM · Aufgaben · Verzeichnis · KI-Studio',
      sub2: 'Für KMUs weltweit. Konform. Souverän. Unlimitiert.',
      ctaPrimary: 'Kostenlos starten',
      ctaSecondary: 'Ich habe einen Code',
      trust1: 'Keine Kreditkarte nötig',
      trust2: 'Setup in 60 Sekunden',
      trust3: 'DSGVO · EU-Hosting',
    },
    proof: { modules: 'Module\ninklusive', compliance: 'voll\nkonform', setup: 'zum\nStart', unlimited: 'Rechnungen &\nKunden' },
    features: {
      tag: 'FUNKTIONEN',
      title1: '9 Module für',
      title2: 'dein gesamtes Unternehmen',
      sub: 'Schluss mit 5 verschiedenen Tools. YNX bündelt alles, was ein modernes Unternehmen braucht — mit KI dort, wo es zählt.',
      items: [
        { title: 'Geteilter Kalender',  desc: 'Kundentermine, Auto-Erinnerungen, Tag/Woche/Monat.' },
        { title: 'Kanban-Aufgaben',     desc: 'Offen / läuft / erledigt. Prioritäten, Zuweisung.' },
        { title: 'Angebote & Rechnungen', desc: 'Auto-Nummerierung, MwSt, PDF & Word, Rechtshinweise.' },
        { title: 'CRM',                 desc: 'USt-IdNr., Verlauf, Notizen, Sofortsuche.' },
        { title: 'Internes Verzeichnis', desc: 'Auto-Durchwahlen, kostenloses Messaging, Click-to-Call.' },
        { title: 'KI-Visual-Studio',    desc: 'Flyer, Plakate, Marketing-Visuals — unlimitiert.' },
        { title: 'KI-Assistent',        desc: 'GPT, Claude, Gemini. Web-Suche, Datei-Analyse.' },
        { title: 'Multi-User-Team',     desc: 'Admin · Buchhaltung · Vertrieb · Mitarbeiter. Volle RBAC.' },
        { title: 'DSGVO & Souveränität', desc: 'Daten pro Firma getrennt, EU-gehostet, exportierbar.' },
      ],
    },
    pricing: {
      tag: 'PREISE', title1: 'Einfaches Versprechen:', title2: 'du zahlst, wenn es funktioniert',
      sub: 'Kostenlos starten. Upgrade auf Solo oder Business, wenn du mehr brauchst. Keine versteckten Stufen.',
      plans: [
        { name: 'Starter', price: '0', tag: 'GRATIS', period: 'für immer',
          desc: 'YNX risikofrei entdecken.',
          features: ['1 Nutzer', '20 Rechnungen / Monat', '50 Kunden', 'Basis-Module', 'Community-Support'],
          cta: 'Kostenlos starten' },
        { name: 'Solo', price: '19', tag: 'BELIEBT', period: '/ Monat',
          desc: 'Für Freiberufler und Selbständige.',
          features: ['1 Nutzer', '50 Rechnungen / Monat', '200 Kunden', 'Alle Module', 'Limitierte KI', 'Limitiertes Studio'],
          cta: 'Abonnieren — 19€/Monat', highlighted: true },
        { name: 'Business', price: '500', tag: 'KMU', period: '/ Monat',
          desc: 'Für KMUs, die alles freischalten wollen.',
          features: ['Unlimitierte Nutzer', 'Unlimitierte Rechnungen', 'Unlimitierte Kunden', 'Unlimitierte KI', 'Stripe Connect', 'IMAP/SMTP', 'Priority Support 24h'],
          cta: 'Abonnieren — 500€/Monat' },
      ],
      addonsTitle: 'À-la-carte-Optionen — je +200€/Monat',
      addonsSub: 'Nur aktivieren, was du brauchst. Jede Option ergänzt Business.',
      addons: [
        { title: 'White-Label',         desc: 'Eigene Domain · Logo + Farben · Kein YNX-Branding.' },
        { title: 'Multi-Land & Sprachen', desc: 'Zweisprachige Rechnungen · EU-USt · 5 Kunden-Sprachen.' },
        { title: 'Unlimitiertes KI-Studio', desc: 'Unlimitiertes Nano Banana · GPT-5 · Web-Suche.' },
        { title: '24/7 Priority Support', desc: 'Direkte Hotline zu Carl TACITA · 2h SLA · Persönliches Onboarding.' },
      ],
    },
    why: {
      tag: 'WARUM YNX', title1: 'Gebaut von einem Unternehmer', title2: 'für Unternehmer.',
      text: 'YNX wurde von Carl TACITA gebaut — der genug davon hatte, 5 verschiedene Tools für sein KMU zu bezahlen. Das Versprechen: ein Abo, ein Login, alle Bausteine eines modernen Unternehmens.',
      p1: ['Schnell.', 'Lokal + Cloud. Kein Warten.'],
      p2: ['Souverän.', 'EU-Daten, jederzeit exportierbar.'],
      p3: ['Multi-Tenant.', 'Deine Daten streng isoliert von anderen Firmen.'],
    },
    faq: {
      tag: 'FAQ', title: 'Häufige Fragen',
      items: [
        ['Sind meine Daten wirklich von anderen Firmen getrennt?', 'Ja. Jede Firma hat einen Workspace mit YNX-XXXXXX-Code. Strikte Isolation auf DB-Ebene.'],
        ['Bekomme ich meine Daten zurück, wenn ich gehe?', 'Jederzeit. Rechnungen als PDF/Word, Kunden als CSV, voller JSON-Export auf Anfrage. Kein Lock-in.'],
        ['Erfüllt YNX die EU-Vorschriften?', 'Ja. Fortlaufende Nummerierung, Rechtshinweise, EU-USt, 10 Jahre Archivierung. EU-Hosting (DSGVO).'],
        ['Wie lange dauert der Start?', 'Unter 60 Sekunden. Firmenname → Zugangscode → erste Rechnung sofort.'],
        ['Wie funktioniert das Stripe-Abo?', 'Du zahlst in 30-Tage-Blöcken per Karte. Kein erzwungener Lastschrifteinzug. Daten bleiben auch ohne Abo zugänglich.'],
      ],
    },
    finalCta: {
      title: 'Bereit, 2 Stunden täglich zu sparen?',
      sub: 'Workspace in 60 Sekunden erstellen. Keine Kreditkarte nötig.',
      cta: 'Jetzt starten',
    },
    footer: {
      tag: 'Das KI-OS für Unternehmen',
      product: 'Produkt', legal: 'Rechtliches', contact: 'Kontakt',
      legalMentions: 'Impressum', cgu: 'AGB', rgpd: 'Datenschutz',
      copyright: '© 2026 YNX by Carl TACITA · Alle Rechte vorbehalten · EU-Hosting',
    },
  },

  it: {
    nav: { features: 'Funzionalità', pricing: 'Prezzi', faq: 'FAQ', login: 'Accedi', start: 'Inizia' },
    hero: {
      badge: 'Novità · L\'OS IA per le imprese',
      title1: 'Tutto il tuo business',
      title2: 'in un unico strumento.',
      sub: 'Agenda · Preventivi · Fatture · Clienti · Attività · Rubrica · Studio IA',
      sub2: 'Pensato per le PMI di tutto il mondo. Conforme. Sovrano. Illimitato.',
      ctaPrimary: 'Inizia gratis',
      ctaSecondary: 'Ho già un codice',
      trust1: 'Nessuna carta richiesta',
      trust2: 'Setup in 60 secondi',
      trust3: 'GDPR · Hosting UE',
    },
    proof: { modules: 'moduli\ninclusi', compliance: 'pienamente\nconforme', setup: 'per\ncominciare', unlimited: 'fatture &\nclienti' },
    features: {
      tag: 'FUNZIONALITÀ',
      title1: '9 moduli per gestire',
      title2: 'tutta la tua impresa',
      sub: 'Basta destreggiarsi tra 5 strumenti diversi. YNX raccoglie tutto ciò che serve a un\'impresa moderna — con l\'IA dove conta davvero.',
      items: [
        { title: 'Agenda condivisa',    desc: 'Appuntamenti, promemoria automatici, viste giorno/settimana/mese.' },
        { title: 'Attività Kanban',     desc: 'Da fare / in corso / fatto. Priorità, scadenze, assegnazione.' },
        { title: 'Preventivi & Fatture', desc: 'Numerazione auto, IVA, export PDF & Word, menzioni legali.' },
        { title: 'CRM',                 desc: 'P.IVA, storico, note, ricerca istantanea.' },
        { title: 'Rubrica interna',     desc: 'Interni automatici, messaggistica gratuita, click-to-call.' },
        { title: 'Studio Visuale IA',   desc: 'Flyer, poster, visual marketing in 1 clic — illimitato.' },
        { title: 'Assistente IA',       desc: 'GPT, Claude, Gemini. Ricerca web, analisi file.' },
        { title: 'Team multi-utente',   desc: 'Admin · Contabile · Vendite · Collaboratore. RBAC completo.' },
        { title: 'GDPR & sovranità',    desc: 'Dati isolati per azienda, ospitati in UE, esportabili.' },
      ],
    },
    pricing: {
      tag: 'PREZZI', title1: 'Promessa semplice:', title2: 'paghi quando funziona',
      sub: 'Inizia gratis. Passa a Solo o Business quando vuoi sbloccare di più. Nessun livello nascosto.',
      plans: [
        { name: 'Starter', price: '0', tag: 'GRATIS', period: 'per sempre',
          desc: 'Scopri YNX senza rischi.',
          features: ['1 utente', '20 fatture / mese', '50 clienti', 'Moduli essenziali', 'Supporto community'],
          cta: 'Inizia gratis' },
        { name: 'Solo', price: '19', tag: 'POPOLARE', period: '/ mese',
          desc: 'Per freelance e partita IVA.',
          features: ['1 utente', '50 fatture / mese', '200 clienti', 'Tutti i moduli', 'IA limitata', 'Studio IA limitato'],
          cta: 'Abbonati — 19€/mese', highlighted: true },
        { name: 'Business', price: '500', tag: 'PMI', period: '/ mese',
          desc: 'Per PMI che vogliono sbloccare tutto.',
          features: ['Utenti illimitati', 'Fatture illimitate', 'Clienti illimitati', 'IA illimitata', 'Stripe Connect', 'IMAP/SMTP', 'Supporto prioritario 24h'],
          cta: 'Abbonati — 500€/mese' },
      ],
      addonsTitle: 'Opzioni à la carte — +200€/mese ciascuna',
      addonsSub: 'Attiva solo ciò che ti serve. Ogni opzione si aggiunge a Business.',
      addons: [
        { title: 'White-label',         desc: 'Dominio personalizzato · Logo + colori · Senza menzione YNX.' },
        { title: 'Multi-paese e lingue', desc: 'Fatture bilingui · IVA UE · 5 lingue per i clienti.' },
        { title: 'Studio IA illimitato', desc: 'Nano Banana illimitato · GPT-5 · Ricerca web.' },
        { title: 'Supporto 24/7',       desc: 'Linea diretta con Carl TACITA · SLA 2h · Onboarding personale.' },
      ],
    },
    why: {
      tag: 'PERCHÉ YNX', title1: 'Creato da un imprenditore', title2: 'per gli imprenditori.',
      text: 'YNX è stato creato da Carl TACITA, stufo di pagare 5 strumenti diversi per gestire la sua PMI. La promessa: un abbonamento, un login, tutti i mattoni di un\'impresa moderna.',
      p1: ['Veloce.', 'Locale + cloud. Niente attese.'],
      p2: ['Sovrano.', 'Dati in UE, esportabili in ogni momento.'],
      p3: ['Multi-tenant.', 'I tuoi dati strettamente isolati dalle altre aziende.'],
    },
    faq: {
      tag: 'FAQ', title: 'Domande frequenti',
      items: [
        ['I miei dati sono davvero isolati?', 'Sì. Ogni azienda ha un workspace con codice YNX-XXXXXX. Isolamento stretto a livello database.'],
        ['Posso riavere i miei dati se lascio YNX?', 'In qualunque momento. PDF/Word per fatture, CSV per clienti, export JSON completo su richiesta. Niente lock-in.'],
        ['YNX è conforme alle normative UE?', 'Sì. Numerazione sequenziale, menzioni legali, IVA UE, archiviazione 10 anni. Hosting UE (GDPR).'],
        ['Quanto ci vuole per iniziare?', 'Meno di 60 secondi. Nome azienda → codice → prima fattura subito.'],
        ['Come funziona l\'abbonamento Stripe?', 'Paghi a blocchi di 30 giorni con carta. Nessun addebito automatico forzato. I tuoi dati restano accessibili anche senza abbonamento.'],
      ],
    },
    finalCta: {
      title: 'Pronto a risparmiare 2 ore al giorno?',
      sub: 'Crea il tuo workspace in 60 secondi. Nessuna carta richiesta.',
      cta: 'Inizia ora',
    },
    footer: {
      tag: 'L\'OS IA per le imprese',
      product: 'Prodotto', legal: 'Legale', contact: 'Contatti',
      legalMentions: 'Note legali', cgu: 'Termini', rgpd: 'Privacy',
      copyright: '© 2026 YNX by Carl TACITA · Tutti i diritti riservati · Hosting UE',
    },
  },
};

const LANG_KEY = 'ynx_lang';

export const detectLang = () => {
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved && DICT[saved]) return saved;
    const nav = (navigator.language || 'fr').slice(0, 2).toLowerCase();
    return DICT[nav] ? nav : 'fr';
  } catch (e) { console.debug('YNX i18n: detectLang failed', e); return 'fr'; }
};

export const setLang = (code) => {
  try { localStorage.setItem(LANG_KEY, code); }
  catch (e) { console.debug('YNX i18n: setLang persist failed', e); }
};
